/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExportedTaskOutputEvaluationAnyOf } from './exportedTaskOutputEvaluationAnyOf';

export type ExportedTaskOutputEvaluation = ExportedTaskOutputEvaluationAnyOf | null;
